/*
  Must be identical to return types from the attention_needed method (artprice_shop)
 */

export const STRIPE_CANCELLED = 'stripe_cancelled';
export const STRIPE_NEED_ACTION = 'stripe_need_action';
export const PAYPAL_CANCELLED = 'paypal_cancelled';
